import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import ReactRouterLink from '../components/ReactRouterLink';
import { UnauthenticatedPaths } from '../constants/Paths';

const SelfRegistrationLink = ({ textLabel, linkLabel, requestStateParams }) => (
    <span
        css={({ linkFontSize }) => css`
            display: flex;
            width: 100%;
            margin-top: 1rem;
            font-size: ${linkFontSize};
            gap: 4px;
            text-align: center;
            justify-content: center;
        `}
    >
        {textLabel}
        <ReactRouterLink
            css={({ linkFontSize }) =>
                css`
                    font-size: ${linkFontSize};
                `
            }
            to={{ pathname: UnauthenticatedPaths.SELF_REGISTER, search: requestStateParams }}
        >
            {linkLabel}
        </ReactRouterLink>
    </span>
);

SelfRegistrationLink.propTypes = {
    linkLabel: PropTypes.string,
    /**
     * A string representation of request state query parameters
     */
    requestStateParams: PropTypes.string,
    textLabel: PropTypes.string,
};

export default SelfRegistrationLink;
